import { render, staticRenderFns } from "./BuyTab1.vue?vue&type=template&id=248a0d23&scoped=true&lang=pug&"
import script from "./BuyTab1.vue?vue&type=script&lang=js&"
export * from "./BuyTab1.vue?vue&type=script&lang=js&"
import style0 from "./BuyTab1.vue?vue&type=style&index=0&id=248a0d23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248a0d23",
  null
  
)

export default component.exports